/**
 * När en hemleverans skickas. Kaffet går ut när gruppens säljperiod är slut,
 * inte direkt efter köpet. Samma text i kassan, på tacksidan och i mejlet.
 */

/** Sista säljdagen, t.ex. "18 november". campaign_end är dagens slut i svensk tid. */
export const periodEndDay = (campaignEnd: number | string | null | undefined): string | null => {
    if (campaignEnd === null || campaignEnd === undefined || campaignEnd === '') return null;
    const date = new Date(campaignEnd);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString('sv-SE', { day: 'numeric', month: 'long', timeZone: 'Europe/Stockholm' });
};

/** "när gruppens säljperiod är slut den 18 november", eller utan datum när det saknas. */
export const homeDeliveryWhen = (campaignEnd: number | string | null | undefined): string => {
    const day = periodEndDay(campaignEnd);
    return day ? `när gruppens säljperiod är slut den ${day}` : 'när gruppens säljperiod är slut';
};

/** Kort, i valet i kassan: "Skickas när säljperioden är slut (18 november)". */
export const homeDeliveryShort = (campaignEnd: number | string | null | undefined): string => {
    const day = periodEndDay(campaignEnd);
    return day ? `Skickas när säljperioden är slut (${day})` : 'Skickas när säljperioden är slut';
};
